export const cssVariables = {
  mobileBreakpoint: '768px',
  tabletBreakpoint: '1024px',
};
